import React from "react";
import { Link } from "react-router-dom";

/**
 * Twilio A2P 10DLC compliant SMS opt-in disclosure.
 *
 * Renders the exact legal language required next to the affirmative
 * SMS-consent control (checkbox on signup or toggle in Profile). The
 * checkbox / toggle itself is rendered by the parent so this component
 * stays purely presentational.
 */
export default function SmsConsentDisclosure({ testId = "sms-consent-disclosure" }) {
  return (
    <p
      data-testid={testId}
      className="text-xs text-[#6B6B6B] leading-relaxed"
    >
      By opting in, you agree to receive recurring automated SMS/text
      messages from LifeGuide at the mobile number provided (account
      notifications, reminders, gift updates, and reflection messages).
      Message frequency may vary. Message and data rates may apply. Reply{" "}
      <strong>STOP</strong> to opt out or <strong>HELP</strong> for help.
      Consent is not a condition of purchase. See our{" "}
      <Link
        to="/terms"
        target="_blank"
        rel="noopener"
        className="text-[#4F6F52] underline underline-offset-2 hover:text-[#3F5A42]"
        data-testid="sms-disclosure-terms-link"
      >
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link
        to="/privacy"
        target="_blank"
        rel="noopener"
        className="text-[#4F6F52] underline underline-offset-2 hover:text-[#3F5A42]"
        data-testid="sms-disclosure-privacy-link"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}
